import React from "react";
import Input from "../../atoms/Input";
import StyledSearchInput from "./SearchInput.styled";
import { ReactComponent as SearchIcon } from "../../../assets/icons/explore.svg";

const SearchInput = ({ placeholder, ...props }: any) => (
  <StyledSearchInput {...props}>
    <Input small Icon={<SearchIcon />} placeholder={placeholder || "Search"} />
  </StyledSearchInput>
);

export default SearchInput;
